import MainLayout from './Layout/MainLayout'; 
import HomePage from './Pages/Home/HomePage'; 

function App() {
  return (
    <MainLayout> {/* Wrapper component for main layout structure */}
      <HomePage/> {/* Main content of the home page, rendered within the layout */}
    </MainLayout>
  );
}

export default App; 
